module.exports = __webpack_public_path__ + "img/adf-navy-sm.4be2afa.webp";